<template>
  <section>
    <div class="flex-column">
      <h2>
        {{ title }}
        <br />
      </h2>
      <img
        :src="'https://www.getquorum.com/assets/images/illustrations/' + image"
        width="300"
        height="300"
      />
      <div v-if="status === 503" class="flex-column">
        <h6>
          We'll be back up and running again soon, please check back later
        </h6>
      </div>
      <div v-else-if="status === 404" class="flex-column">
        <h6>
          Please ensure you access this page from the verified link provided in
          the email
        </h6>
      </div>
      <div v-else class="flex-column">
        <h3>Oops, there was an error loading the form</h3>
        <h6>
          Please ensure you access this page from the verified link provided in
          the email
        </h6>
      </div>
      <p class="caption">
        If you continue to experience issues, please contact us at
        <a href="mailto:voters@getquorum.com">voters@getquorum.com</a>
      </p>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters(['error']),
    status() {
      if (this.error.message && this.error.message.status) {
        return this.error.message.status;
      }
      return 'Error';
    },
    message() {
      if (this.error.message && this.error.message.message) {
        return this.error.message.message;
      }
      return 'Unknown';
    },
    image() {
      return this.status === 503 ? 'about_us.png' : '404.png';
    },
    title() {
      if (this.status === 404) {
        return 'Meeting Not Found';
      } else if (this.status === 503) {
        return 'Under Maintenance';
      }
      return 'Error';
    }
  }
};
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
h2 {
  font-size: 40px;
  font-family: 'century gothic';
  font-weight: lighter;
  text-align: center;
  color: #606060;
  margin-top: 0;
}
h3 {
  font-size: 24px;
  color: gray;
  margin: 16px 0;
}
h6 {
  font-size: 18px;
  color: gray;
  font-weight: lighter;
  margin-top: 0;
}
.caption {
  font-size: 14px;
  color: #606060;
}

@media only screen and (max-width: 900px) {
  h2 {
    font-size: 30px;
  }
  h3 {
    font-size: 20px;
    text-align: center;
  }
  h6 {
    font-size: 18px;
    text-align: center;
  }
  .caption {
    font-size: 12px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Error.vue